import { http } from "../../../shared/api/http"
import { Media } from "../../../pages/profiles/types"

export const listMyPortfolioApi = () => {
  return http.get<Media[]>(
    "api/users/me/portfolio"
  )
}

export const uploadPortfolioItemApi = (file: File) => {
  const formData = new FormData()
  formData.append("file", file)

  return http.post<Media>(
    "api/users/me/portfolio/upload",
    formData
  )
}
